export default __webpack_public_path__ + "static/media/done_white.ad4c2884.svg";